import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { fetchApi, getStructure } from "../Funciones";
import { ModuleData } from "./ModuleLib";
import React from "react";
import { Spinner } from "react-bootstrap";

export const Index: React.FC = () => {

	let params = useParams();
	var pid = params.id?.toString();

	const [estructura, setEstructura] = useState<ModuleData[]>([])
	const [plantilla, setPlantilla] = useState<ModuleData[]>([])
	const [navegacion, setNavegacion] = useState<any[]>([])
	const [current, setCurrent] = useState("")
	const [cargando, setCargando] = useState(true)

	const viewPage = async (id: any) => {
		setCargando(true)
		let resp = await fetchApi("", "page", {
			cmd: "view",
			pid: pid
		})

		var es = JSON.parse(resp.page["structure"].replaceAll("\n", "\\n").replaceAll("\r", "\\r").replaceAll("\t", "\\t"))
		var pl = JSON.parse(resp.template["structure"].replaceAll("\n", "\\n").replaceAll("\r", "\\r").replaceAll("\t", "\\t"))

		setEstructura(await getStructure(es))
		setCurrent(resp.page["id"])
		setPlantilla(await getStructure(pl))
		setCargando(false)
		if (resp.nav) {
			setNavegacion(resp.nav)
		}
	}

	useEffect(() => {
		viewPage(pid)
		// eslint-disable-next-line
	}, [pid])

	return <div className={"visible_"+current}>
		<style>{`.visible_pagina.visible_${current}{display:inline-block;}`}</style>
		{cargando && <Spinner animation="border" className="float-start" />}
		{!cargando && plantilla.length > 0 && plantilla.map((data: ModuleData) => {
			if (data.Module) {
				return <data.Module.Component key={data.Instance} data={data.Data!} nav={navegacion} currentPage={current} moduleData={
					estructura.map((data: ModuleData) => {
						if (data.Module) {
							return <data.Module.Component key={data.Instance} data={data.Data!} currentPage={current} nav={navegacion!} />
						}
						return <React.Fragment key={data.Instance} />
					})
				} />
			}
			return <React.Fragment key={data.Instance} />
		})}
	</div>
}